import React from 'react'
import {handle} from '../events'
import smoke from './smoke_1.png'
import bang from './bang_1.png'
import {sprite} from '../system/sprite'
import {genericSprite, lerp, register} from '../utils'
import {addGameObject, createGameObject} from '../system'
import {getState} from '../game-surface'
import {registerSound} from '../sound'

export const explosionSound = registerSound('/bomb explosion.mp3')

export const explosion = register('explosion', {
    initialize() {
        this.$.y = -2000
    },
    postInitialize() {
        this.$.items = this.items = [
            this.$.addChild(
                createGameObject(
                    {},
                    {...sprite.config({Sprite: genericSprite(bang)})}
                )
            ),
            this.$.addChild(
                createGameObject(
                    {},
                    {...sprite.config({Sprite: genericSprite(smoke)})}
                )
            ),
            this.$.addChild(
                createGameObject(
                    {},
                    { ...sprite.config({ Sprite: genericSprite(smoke) }) }
                )
            ),
            this.$.addChild(
                createGameObject(
                    {},
                    { ...sprite.config({ Sprite: genericSprite(smoke) }) }
                )
            ),
        ]
    },
    states: {
        default: {
            enter() {
                this.$.visible = false
                this.$.y = -2000
                let state = getState()
                state.explosions = state.explosions || []
                state.explosions.push(this.document)
            },
        },
        go: {
            enter() {
                this.$.visible = true
                this.$.scale = 0.08
                this.$.opacity = 2
                let items = this.items
                items[0].scale = 2
                items[0].x =0
                items[0].y = 0
                items[0].rotationSpeed = 1
                items[0].opacity = 1
                items[0].rotation = Math.random() * 300
                for(let i = 1; i < items.length-1; i++) {
                    let item = items[i]
                    item.scale =  Math.random() * 1.4 + .7
                    item.rotation =  Math.random() * 300
                    item.opacity =  Math.random() *.4 + .2
                    item.x = (Math.random() * 600 - 300) * 2
                    item.y =  (Math.random() * 600 - 300) * 2
                    item.rotationSpeed = 1 + Math.random() * 5
                }
            },
            methods: {
                update(dt) {
                    let items = this.items
                    for(let item of items) {
                        item.rotation = (item.rotation || 0) + (20 * dt * (item.rotationSpeed||1))
                    }
                    this.$.opacity = lerp(this.$.opacity, 0, dt * 3)
                    this.$.scale = lerp(this.$.scale, 1, dt * .2)
                    if(this.$.opacity < .01) {
                        this.$.setState('default')
                    }
                },
            },
        },
    },
})

export function explode(position, fire = true) {
    const {explosions = []} = getState()
    if (!explosions.length) return
    let bang = explosions.pop()
    Object.assign(bang, position)
    bang.items[0].visible = fire
    bang.setState('go')
}


handle('initializeGame', () => {
    for (let i = 0; i < 6; i++) {
        addGameObject(
            {z: 4000},
            {
                explosion
            }
        )
    }
})
